import * as React from 'react';
import styled from 'styled-components';
import { Card, Col, Row } from 'antd';
import SimpleSelect from 'components/Forms/SimpleSelect';

export const HideContentSimpleSelect = styled(SimpleSelect)`
    .ant-select-selection-selected-value i {
        display: none;
    }
`;